module.exports = __webpack_public_path__ + "img/a8815.f9c32a17.svg";